import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ArticleCard from "@/components/ArticleCard";
import { SEO } from "@/components/SEO";

export default function Search() {
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const run = (query) => {
    if (!query) { setItems([]); return; }
    setLoading(true);
    api.get("/articles", { params: { q: query, limit: 40 } })
      .then((r) => setItems(r.data.items || []))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    const query = params.get("q") || "";
    setQ(query);
    run(query);
  }, [params]);

  const submit = (e) => {
    e.preventDefault();
    setParams({ q });
  };

  return (
    <>
      <SEO title={`Search · ITTV News`} description="Search stories, essays and dispatches." />
      <div className="container-editorial py-12">
        <div className="kicker text-[color:var(--accent)] mb-3">Archive</div>
        <h1 className="font-serif text-5xl md:text-7xl font-bold tracking-tight leading-none">Search</h1>
        <form onSubmit={submit} className="mt-8 flex border max-w-3xl" style={{ borderColor: "hsl(var(--border-hsl))" }}>
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search stories, authors, tags…" className="flex-1 bg-transparent outline-none px-4 py-3 font-serif text-xl" data-testid="search-page-input" autoFocus />
          <button className="btn-accent" data-testid="search-page-submit">Search</button>
        </form>
        <div className="mt-4 text-sm text-[color:var(--text-muted)]" data-testid="search-status">
          {loading ? "Searching…" : q ? `${items.length} result${items.length === 1 ? "" : "s"} for "${q}"` : "Type a query to begin."}
        </div>
        <div className="mt-12 grid md:grid-cols-3 gap-8">
          {items.map((a) => <ArticleCard key={a.slug} article={a} />)}
        </div>
      </div>
    </>
  );
}
